import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const OutlinedSelect = (props) => {
  const itemsHTML = props.items.map(item => {
    return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>;
  });
  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 300, width: props.width ? props.width : 600, margin:"16px 0" }}>
        <InputLabel id={props.id + "-label"}>{props.label}</InputLabel>
        <Select
          labelId={props.id + "-label"}
          id={props.id}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          label={props.label}
        >{itemsHTML}
        {/*  <MenuItem value="">*/}
        {/*  <em>None</em>*/}
        {/*</MenuItem>*/}
        {/*  <MenuItem value={10}>Twenty</MenuItem>*/}
        {/*  <MenuItem value={21}>Twenty one</MenuItem>*/}
        {/*  <MenuItem value={22}>Twenty one and a half</MenuItem>*/}
        </Select>
      </FormControl>
    </div>
  );
}

export default OutlinedSelect;